import type { ReshopAlertInputType } from '../apollo/graphql/user_preference.mutation';

export interface OptionType {
  label: string;
  value: string;
  preference?: ReshopAlertInputType;
}

export const TITLE_A = 'Get notified of better insurance rates';
export const TITLE_B = 'How often would you like us to check for best insurance rates?';

export const SUBTITLE_A = 'We’ll continue to monitor the rate and send a reminder at your chosen time.';
export const SUBTITLE_B = 'We’ll keep an eye on rates and notify you on your schedule.';

export enum OptionValues {
  BEFORE_RENEWAL = 'before-renewal',
  WHENEVER_GOOD_PRICE = 'whenever-good-price',
  LET_ME_CHOOSE = 'let-me-choose',
  NOT_INTERESTED_NOW = 'not-interested-now',
  EVERY_3_MONTHS = 'every-3-months',
  EVERY_6_MONTHS = 'every-6-months',
  EVERY_12_MONTHS = 'every-12-months',
  LET_JERRY_DECIDE = 'let-jerry-decide',
}

export const OPTIONS_A: OptionType[] = [
  {
    label: 'Before policy renewal',
    value: OptionValues.BEFORE_RENEWAL,
    preference: null,
  },
  {
    label: 'Whenever the price is good',
    value: OptionValues.WHENEVER_GOOD_PRICE,
    preference: null,
  },
  {
    label: 'Let me choose a date',
    value: OptionValues.LET_ME_CHOOSE,
    preference: null,
  },
  {
    label: 'I’m not interested now',
    value: OptionValues.NOT_INTERESTED_NOW,
    preference: null,
  },
] as const;

export const OPTIONS_B: OptionType[] = [
  {
    label: 'Every 3 months',
    value: OptionValues.EVERY_3_MONTHS,
    preference: {
      type: 'periodic',
      value: '3m',
    },
  },
  {
    label: 'Every 6 months',
    value: OptionValues.EVERY_6_MONTHS,
    preference: {
      type: 'periodic',
      value: '6m',
    },
  },
  {
    label: 'Every 12 months',
    value: OptionValues.EVERY_12_MONTHS,
    preference: {
      type: 'periodic',
      value: '12m',
    },
  },
  {
    label: 'Let Jerry decide',
    value: OptionValues.LET_JERRY_DECIDE,
  },
  {
    label: 'I’m not interested now',
    value: OptionValues.NOT_INTERESTED_NOW,
    preference: null,
  },
] as const;
